import React from "react";

const LogoAmmagamma = ({ height = "12", width = "auto" }) => (
  <div className="flex-shrink-0 flex items-center px-4">
    <img
      className={`h-${height} w-${width}`}
      src={process.env.PUBLIC_URL + "/am-logo.svg"}
      alt="ammagamma logo"
      type="image/svg+xml"
    />
  </div>
);

export default LogoAmmagamma;
